// The Input Component
// This component will give the us the most
// import functionality. We will use this
// to get input from user.

// Libraries
import React, { useEffect, useState } from "react";

// Component
function Button({
  name = "",
  value = "Button",
  type = "button",
  className = "",
  buttonType = "",
  onClick,
}) {
  const [style, setStyle] = useState("");

  // Function to handle onClick event
  const onClickEvent = () => {
    type !== "submit" && onClick(name);
  };

  useEffect(() => {
    // Setup class based on type
    switch (buttonType) {
      // Handle case
      case "secondary":
        // Setup as secondary
        setStyle(
          "bg-white-1 border-white-3 h-10 border text-lg text-black-1 hover:text-accent-primary hover:border-accent-hover"
        );
        break;

      case "danger":
        // Setup as danger
        setStyle("bg-alert-error-fill h-11 text-lg text-white-1 px-2");
        break;

      case "link":
        // Setup as link
        setStyle("border-none h-1 text-lg text-black-1");
        break;

      case "link-2":
        // Setup as link
        setStyle(
          "w-24 bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white py-2 border border-blue-500 hover:border-transparent rounded-full h-8"
        );
        break;

      case "primary":
        // Setup as link
        setStyle(
          "w-full px-6 h-10 bg-blue-1 text-sm lg:text-lg rounded-md text-white-1 hover:bg-blue-hover"
        );
        break;

      case "primary-2":
        // Setup as link
        setStyle(
          "w-full px-6 h-14 bg-blue-1 text-lg rounded-md text-white-1 hover:bg-blue-hover"
        );
        break;

      case "cancel":
        // Setup as secondary
        setStyle(
          "bg-white-1 border-blue-1 w-32 h-10 border text-lg text-black-1 hover:text-accent-primary hover:border-accent-hover rounded"
        );
        break;

      case "secondary-2":
        // Setup as secondary
        setStyle(
          "bg-blue-1 border-blue-1 w-32 h-10 border text-lg text-white-1 hover:border-accent-hover hover:bg-blue-3 rounded "
        );
        break;

      case "tag":
        // Setup as secondary
        setStyle("w-auto h-8 p-2 text-sm text-white-1 rounded");
        break;

      case "search":
        setStyle("bg-pink-1 h-9 text-lg text-white-1 px-2 rounded-md");
        break;

      case "Interview":
        setStyle("bg-pink-1 h-9 md:text-base text-xs text-white-1 px-5 rounded");
        break;

      case "miniInterviewButton":
        setStyle("bg-[#0069FF] h-9 text-sm text-white-1 mt-2 px-4 rounded-md");
        break;

      case "nextCandidate":
        setStyle("bg-pink-1 h-9 text-sm text-white-1 mt-2 px-4 rounded-md");
        break;
        
      case "request":
        setStyle("bg-blue-7 h-9 text-base text-blue-1 px-3 rounded");
        break;

      case "next":
        setStyle("w-11/12 px-6 h-10 bg-blue-1 text-sm lg:text-lg rounded text-white-1 hover:bg-blue-hover");
        break;

      default:
        // Setup as default
        setStyle(
          "w-full h-10 bg-accent-primary text-lg text-white-1 hover:bg-accent-hover"
        );
        break;
    }
  }, [buttonType]);

  // Render Button
  return (
    <button
      type={type}
      onClick={onClickEvent}
      className={`flex justify-center items-center font-text py-1 ${
        buttonType == "danger" ? "rounded-full" : "sm"
      }  box-border transition-colors focus:outline-none ${className} ${style}`}
    >
      {value}
    </button>
  );
}

// Export the Component
export default Button;

